import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    templateapplies: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_TEMPLATEAPPLY_SELECT_IDS (store, ids) {
      store.templateapplies.selectIds = ids
    },
    REMOVE_TEMPLATEAPPLY_SELECT_IDS (store, ids) {
      store.templateapplies.selectIds = store.templateapplies.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_TEMPLATEAPPLY_SELECT_ID (store, id) {
      store.templateapplies.selectId = id
    },
    SET_TEMPLATEAPPLY_FILTERS (store, filters) {
      store.templateapplies.filters = filters
    },
    SET_TEMPLATEAPPLY_PAGINATE (store, val) {
      store.templateapplies.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getTemplateapplies: (store, getters) => {
      return store.templateapplies.selectIds.map((id) => {
        return getters['entities/templateapplies/find'](id)
      })
    },
    getTemplateappliesFilters: (store, getters) => {
      return store.templateapplies.filters
    },
    getTemplateappliesPaginate: (store, getters) => {
      return store.templateapplies.paginate
    },
    getTemplateapply: (store, getters) => {
      return getters['entities/templateapplies/find'](store.templateapplies.selectId) || {}
    }
  },
  actions: {
    /*
    selectTemplateapplies
    */
    selectTemplateapplies ({commit, dispatch, getters, state}, filters) {
      return dispatch('getTemplateapplies', filters)
      .then((response) => {
        commit('SET_TEMPLATEAPPLY_FILTERS', filters)
        commit('SET_TEMPLATEAPPLY_PAGINATE', response)
        commit('SET_TEMPLATEAPPLY_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectTemplateapplies
    */
    refreshSelectTemplateapplies ({commit, dispatch, getters, state}) {
      return dispatch('selectTemplateapplies', getters.getTemplateappliesFilters)
    },
    /*
    selectTemplateapply
    */
    selectTemplateapply ({commit, dispatch, getters, state}, id) {
      return dispatch('getTemplateapplyById', id)
      .then((response) => {
        commit('SET_TEMPLATEAPPLY_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getTemplateapplies
    */
    getTemplateapplies ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/templateapplies`, {params: filters})
      .then((response) => {
        return dispatch('entities/templateapplies/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.templateapplies || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getTemplateapplyById
    */
    getTemplateapplyById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/templateapplies/${id}`)
      .then((response) => {
        return dispatch('entities/templateapplies/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.templateapplies[0]
      })
    },
    /*
    createTemplateapply
    */
    createTemplateapply ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/templateapplies`, data)
      .then((response) => {
        return dispatch('entities/templateapplies/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.templateapplies[0]
      })
    },
    /*
    updateTemplateapply
    */
    updateTemplateapply ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/templateapplies/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/templateapplies/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.templateapplies[0]
      })
    },
    /*
    deleteTemplateapply
    */
    deleteTemplateapply ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/templateapplies/${id}`)
      .then((response) => {
        commit('REMOVE_TEMPLATEAPPLY_SELECT_IDS', [id])
        dispatch('entities/templateapplies/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Templateapply.js